import { createContext, createElement, useContext } from 'react';
import useLocalStorageState from 'util/localStorage/useLocalStorageState';

const NavigationMenuContext = createContext(null);

export const NavigationMenuProvider = ({ children }) => {
  const navigationMenuState = useLocalStorageState('submenuOpen', true);

  return createElement(NavigationMenuContext.Provider, { value: navigationMenuState }, children);
};

export const useNavigationMenu = () => {
  const context = useContext(NavigationMenuContext);
  if (!context) {
    throw new Error('useNavigationMenu must be used within a NavigationMenuProvider');
  }
  return context;
};
